import { useEffect } from 'react';

/**
 * Attach a scroll listener to a container and call onLoadMore
 * when the user scrolls past 3/4 of the container height.
 *
 * The hook is intentionally simple; gate conditions should live in onLoadMore.
 */
export const useScrollLoadMore = (
  containerSelector: string,
  onLoadMore: () => void,
  disabled: boolean,
) => {
  useEffect(() => {
    const container = document.querySelector(
      containerSelector,
    ) as HTMLElement | null;
    if (!container) return;

    const handleScroll = () => {
      if (disabled) return;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      if (scrollTop + clientHeight >= (3 * scrollHeight) / 4) {
        onLoadMore();
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [containerSelector, onLoadMore, disabled]);
};
